import { z } from "zod";

export const ChecklistServicoAmbienteCopiaSchema = z.object({
    idChecklistServico: z.number().int().optional(),
    ordem: z.string().nonempty({ message: "A ordem é obrigatória." }),
    descricao: z.string().nonempty({ message: "A descrição é obrigatória." }),
});

export type ChecklistServicoAmbienteCopiaForm = z.infer<typeof ChecklistServicoAmbienteCopiaSchema>;

export const defaultChecklistServicoAmbienteCopiaForm: Partial<ChecklistServicoAmbienteCopiaForm> = {
    idChecklistServico: undefined,
    ordem: '',
    descricao: '',
};
